<div class="container pt-3">
  <rbb-side-menu-headline description="Erstellen, Bearbeiten und Löschen von Formulargruppen." headline="Formulargruppen" icon="fas fa-copy"/>

  <div class="row mb-4">
    <div class="col">
      <a class="btn btn-sm btn-primary fw-bold" routerLink="/form-groups/new">Formulargruppe erstellen</a>
    </div>
  </div>

  @if (!formGroups) {
    <div class="text-center m-auto mt-5">
      <rbb-loader/>
      <small class="text-secondary d-block">Formulargruppen werden geladen...</small>
    </div>
  } @else {
    <rbb-table [responsiveBreakpoint]="'lg'" [columns]="columns" [values]="formGroups" [sort]="true" [pageSizes]="[20]" [search]="true" searchType="GENERAL" [tableData]="tableData"/>
    <ng-template let-column="column" let-value="value" #tableData>
      @switch (column.field) {
        @case ('hide') {
          <td class="text-left">
            @if (value[column.field]) {
              <span class="text-danger"><i class="far fa-eye-slash"></i></span>
            } @else {
              <span class="text-success"><i class="far fa-eye"></i></span>
            }
          </td>
        }
        @case ('edit') {
          <td class="td-icon">
            <a routerLink="/form-groups/{{value.id}}"><i class="fas fa-edit  d-inline-block pointer transform grow-effect text-secondary" data-toggle="tooltip" data-placement="top" aria-hidden="true" title="Bearbeiten"></i></a>
          </td>
        }
        @case ('delete') {
          <td class="td-icon">
            <i class="fas fa-times d-inline-block pointer transform grow-effect text-danger" data-toggle="tooltip" data-placement="top" aria-hidden="true" title="Löschen" (click)="openModal(value.id)"></i>
          </td>
        }
        @default {
          <td>{{ value[column.field] }}</td>
        }
      }
    </ng-template>
  }
</div>


<ng-template #ngModal>
  <div class="modal-header pb-2 pt-2">
    <h5 class="modal-title">
      <span>Formulargruppe löschen</span>
    </h5>
  </div>
  <div class="modal-body p-3">
    <div class="row">
      <div class="col-12">
        <p>Wollen Sie die Formulargruppe wirklich unwiderruflich löschen?</p>
      </div>
    </div>
  </div>
  <div class="modal-footer pb-2 pt-2">
    <button (click)="deleteFormGroup()" class="btn btn-danger btn-sm"><i class="fas fa-trash-alt" aria-hidden="true"></i>&ensp;Löschen</button>
    <button (click)="closeModal()" class="btn btn-secondary btn-sm" type="button"><i class="fas fa-times" aria-hidden="true"></i>&ensp;Schließen</button>
  </div>
</ng-template>

